<template>
  <md-card class="license-card">
    <md-progress-bar v-if="loading" md-mode="query" />
    <md-card-content class="license-card-content">
      <div v-if="error" class="form-error">{{ error.message }}</div>          
      <img src="../../../assets/VRP_logo_Horizontal.jpg" alt="VRpatients Logo" class="vrp-logo">        
      <md-content class="license-content md-scrollbar">
        <pdf
          v-for="i in numPages"
          :key="i"
          :src="src"
          :page="i"
        />
      </md-content>
      <md-radio v-model="state.agree" :value="true">I agree with the license agreement</md-radio>
      <md-radio v-model="state.agree" :value="false">I do not agree with the license agreement</md-radio>
      <div class="actions" style="justify-contet: right">
        <md-button
          class="md-primary md-raised"
          :disabled="!state.agree || loading"
          @click="next"
        >
          Next
        </md-button>
      </div>
    </md-card-content>
  </md-card>
</template>

<script>
import pdf from 'vue-pdf'

export default {
  name: 'license-form',
  components: {
    pdf,
  },
  props: {
    loading: { 
      type: Boolean, 
      default: false,
    },
    error: { 
      type: Object, 
      default: null,
    }
  },
  data() {
		return {
      state: {
        agree: false,
      },
			src: null,
			numPages: undefined,
		}
	},
  created() {
    this.src = pdf.createLoadingTask('EULA.pdf');
  },
  mounted() {
		this.src.promise.then(pdf => {
			this.numPages = pdf.numPages;
		});
  },
  methods: {
    next() {
      this.$emit('acceptLicense');
    },
  },
};
</script>

<style scoped>
.license-card {
  padding: 20px 25px 0px;
}

.license-card-content {
  display: flex;
  flex-direction: column;
}
.vrp-logo {
  max-width: 300px;
  margin-bottom: 20px;
}
.license-content {
  width: 800px;
  min-height: 600px;
  max-height: 600px;
  margin-bottom: 8px;
  overflow: auto;
  border: solid 1px gray;
}
.md-radio {
  margin: 8px 16px 4px 0;
}
.actions {
  display: flex;
  justify-content: flex-end;
}
</style>
